import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { TourItem } from 'src/app/model/tour/tour-item';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { PrintAddressPipe } from 'src/app/pipes/print-address.pipe';
import { ImmoIPPlacerTourViewHelper } from '../../helper/immo-ip-placer-tour-view-helper';

export class ImmoIPPlacerTourRouteHelper {
  private constructor() {}

  static processTourItems(
    tourItems: TourItem[],
    printAddressPipe: PrintAddressPipe,
    formatPhoneNumber: FormatPhoneNumber
  ): void {
    if (!CollectionHelper.isPopulated(tourItems)) {
      return;
    }
    tourItems.forEach(ti => {
      ImmoIPPlacerTourViewHelper.setTourItemBackgroundClass(ti);
      if (ti.subProject != null) {
        ImmoIPPlacerTourViewHelper.processSubProject(ti.subProject);
        ImmoIPPlacerTourViewHelper.processProjectPlacement(
          ti.subProject,
          printAddressPipe,
          false,
          formatPhoneNumber
        );
        ImmoIPPlacerTourViewHelper.setTypeDisplays(ti.subProject);
      }
    });
  }
}
